module.exports = __webpack_public_path__ + "static/img/why-micro-2.af0db464.svg";